export const getFolderPathFromS3Key = (s3Key, projectId) => {
  const prefix = `project-files/$${projectId}/`;
  if (!s3Key?.startsWith(prefix)) {
    return "";
  }
  const remainder = s3Key.slice(prefix.length);
  if (!remainder.includes("/")) {
    return "";
  }
  return remainder.slice(0, remainder.lastIndexOf("/"));
};

export const parseListProjectFilesResponse = (data) => {
  if (Array.isArray(data)) {
    return { files: data, folderPaths: [], adminOnlyFolderPaths: [] };
  }
  return {
    files: data.files || [],
    folderPaths: data.folder_paths || [],
    adminOnlyFolderPaths: data.admin_only_folder_paths || [],
  };
};

export const enrichFilesWithFolderPath = (files, projectId) =>
  files.map((file) => ({
    ...file,
    folder_path:
      file.folder_path ?? getFolderPathFromS3Key(file.s3_key, projectId),
  }));

export const deriveFolderPathsFromFiles = (files) => {
  const paths = new Set();
  files.forEach((file) => {
    const folderPath = file.folder_path || "";
    if (!folderPath) {
      return;
    }
    paths.add(folderPath);
    const parts = folderPath.split("/");
    for (let i = 1; i < parts.length; i += 1) {
      paths.add(parts.slice(0, i).join("/"));
    }
  });
  return paths;
};

export const mergeFolderPaths = (folderPaths, files) => {
  const merged = new Set(folderPaths);
  deriveFolderPathsFromFiles(files).forEach((path) => merged.add(path));
  return [...merged];
};

export const getChildFolderPaths = (folderPaths, currentFolderPath) => {
  const prefix = currentFolderPath ? `${currentFolderPath}/` : "";
  const children = new Set();
  folderPaths.forEach((folderPath) => {
    if (currentFolderPath && folderPath === currentFolderPath) {
      return;
    }
    if (!folderPath.startsWith(prefix)) {
      return;
    }
    const remainder = folderPath.slice(prefix.length);
    if (!remainder) {
      return;
    }
    const childPath = remainder.split("/")[0];
    children.add(currentFolderPath ? `${currentFolderPath}/${childPath}` : childPath);
  });
  return [...children].sort();
};

export const buildFolderRow = (folderFullPath) => {
  const name = folderFullPath.split("/").pop();
  const parentPath = folderFullPath.includes("/")
    ? folderFullPath.slice(0, folderFullPath.lastIndexOf("/"))
    : "";
  return {
    id: `folder:${folderFullPath}`,
    name,
    type: "folder",
    is_folder: true,
    folder_path: parentPath,
    folder_full_path: folderFullPath,
    created_at: null,
    s3_key: null,
  };
};

export const isFolderRowId = (id) => String(id).startsWith("folder:");

export const getFolderLabel = (folderFullPath) =>
  folderFullPath.split("/").join(" / ");
